// extracted by mini-css-extract-plugin
var _1 = "buttons--WTWVLwuS";
var _2 = "panel--RePx9aEM";
var _3 = "text--foeEFnHh";
var _4 = "warningContainer--wmmYf26y";
export { _1 as "buttons", _2 as "panel", _3 as "text", _4 as "warningContainer" }
